
const isAnimationDisabled = (propsdisableAnimation, disableAnimation) => propsdisableAnimation === false ? false : propsdisableAnimation || disableAnimation;


export { isAnimationDisabled as default };